export default "__VITE_ASSET__GIKMP6Yj__"